// Must be imported FIRST: marks the Android TRMD app as "desktop app" before any module reads window.tiroDesktopApp.
if (typeof window !== "undefined" && /TRMDPerformance\//.test(navigator.userAgent || "")) {
  window.tiroDesktopApp = true;
  window.tiroDesktop = true;
}
if (typeof window !== "undefined" && window.tiroDesktopApp) document.documentElement.classList.add("exe-theme");
